// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zAhyv","sloganText":"styles_sloganText__AyPyl","avisoText":"styles_avisoText__nZNif","body":"styles_body__iCzFY","aboutIcon":"styles_aboutIcon__rFZEA"};